import Vue from 'vue'
import Vuex from 'vuex'
import utils from '@/core/h5/utils/index'
// import { bytesToSize } from "mpa-uploader/src/utils";
import { bytesToSize } from '../../../../utils/mpaUploader/utils';
import { COPY_PERMISSION } from "@/constants/file";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isPcMode: true,
        onlineUserInfo: [],
        currentUserInfo: {},

        tasks: [],
        speeds: [],
        progresses: [],
        fileAuth: '',
        docInfo: null,
        precheckDocInfo: null,//和file/node接口返回的数据结构不一致，不改卵用docInfo
        wikiSpaceInfo: null, //知识库空间信息

        curSelectRecentType: 1,
        currentFilePage: 0,
        currentMinePage: 0,
        currentKBPage: 0,
        currentStarPage: 0,
        currentFileId: '',
        recentViewShow: false,
        cloudI18n: 'zh-cn',
        isMettingDoc: false,
        //支持考培系统用户信息
        showType: '',
        userInfo: null,
        tocaEditor: null,
        shareAuthTip: '',
        officePreviewModeInfo: null,
        downloadIds: [], //下载的文件ID
        wikiSpaceInfo: null, //知识库空间信息
        copyPermission: COPY_PERMISSION[0].id,
        isCanCopy: true,
    },
    getters: {
        containDownloadId: state => (downloadId) => {
            return state.downloadIds.includes(downloadId);
        }
    },
    mutations: {
        __ADD_DOWNLOAD_IDS(state, e) {
            if (!state.downloadIds.includes(e)) {
                state.downloadIds.push(e);
            }
        },
        REMOVE_DOWNLOADIDS(state, e) {
            const index = state.downloadIds.indexOf(e);
            if (index !== -1) {
                state.downloadIds.splice(index, 1);
            }
        },
        SET_DOC_INFO(state, e) {
            state.docInfo = e
        },
        SET_PRECHECK_DOC_INFO(state, e) {
            state.precheckDocInfo = e
        },
        SET_FILE_AUTH(state, e) {
            state.fileAuth = e
        },
        SET_IS_PC_MODE(state, e) {
            state.isPcMode = e
        },
        SET_ONLINE_USERS(state, e) {
            state.isPcMode = e
        },
        SET_CURRENT_USER_INFO(state, e) {
            state.currentUserInfo = e;
        },

        // 上传任务处理
        NEW_TASKS(state, e) {
            state.tasks.push(...e);
        },
        REMOVE_TASKS(state, e) {
            const index = state.tasks.findIndex((task) => task.tid === e);
            state.tasks.splice(index, 1);
        },
        CHANGE_TASK_STATUS(state, e) {
            const task = state.tasks.find((task) => task.tid === e.tid);
            task.status = e.status;
        },

        CHANGE_UPLOAD_SPEED(state, e) {
            const speed = state.speeds.find((t) => t.tid === e.tid);
            if (speed) {
                speed.rate = bytesToSize(e.rate);
                speed.commit = e.commit;
            } else {
                state.speeds.push(e);
            }
        },

        CHANGE_UPLOAD_PROGRESS(state, e) {
            const progress = state.progresses.find((t) => t.tid === e.tid);
            if (progress) {
                progress.total = e.total;
                progress.uploaded = e.uploaded;
            } else {
                state.progresses.push(e);
            }
        },
        SET_CUR_SELECT_RECENT_TYPE(state, e) {
            state.curSelectRecentType = e;
        },
        SET_CURRENT_FILE_PAGE(state, e) {
            state.currentFilePage = e;
        },
        SET_CURRENT_MINE_PAGE(state, e) {
            state.currentMinePage = e;
        },
        SET_CURRENT_KB_PAGE(state, e) {
            state.currentKBPage = e;
        },
        SET_CURRENT_STAR_PAGE(state, e) {
            state.currentStarPage = e;
        },
        SET_CURRENT_FILE_ID(state, e) {
            state.currentFileId = e;
        },
        SET_RECENT_VIEW_SHOW(state, e) {
            state.recentViewShow = e;
        },
        SET_CLOUD_I18N(state, e) {
            state.cloudI18n = e;
        },
        SET_IS_METTING_DOC(state, e) {
            state.isMettingDoc = e;
        },
        SET_SHOW_TYPE(state, e) {
            state.showType = e;
        },
        SET_USER_INFO(state, e) {
            state.userInfo = e;
        },
        SET_TOCA_EDITOR(state, e) {
            state.tocaEditor = e;
        },
        SET_SHARE_AUTH_TIP(state, e) {
            state.shareAuthTip = e;
        },
        SET_OFFICE_PREVIEW_MODE_INFO(state, e) {
            state.officePreviewModeInfo = e;
        },
        SET_WIKI_SPACE_INFO(state, val) {
            state.wikiSpaceInfo = val;
        },
        SET_COPY_PERMISSION(state, val) {
            state.copyPermission = val;
        },
        SET_IS_CAN_COPY(state, val) {
            state.isCanCopy = val;
        },
    },
    actions: {
        addDownloadIds(context, value) {
            context.commit('__ADD_DOWNLOAD_IDS', value);
        },
        removeDownloadIds(context, value) {
            context.commit('REMOVE_DOWNLOADIDS', value);
        },
        setDocInfo({ commit }, value) {
            commit('SET_DOC_INFO', value)
        },
        setPrecheckDocInfo({ commit }, value) {
            commit('SET_PRECHECK_DOC_INFO', value)
        },
        setFileAuth({ commit }, value) {
            commit('SET_FILE_AUTH', value)
        },
        setIsPcMode({ commit }) {
            const mode = utils.isPcMode()
            commit('SET_IS_PC_MODE', mode)
        },
        setOnlineUsers({ commit }, value) {
            commit('SET_ONLINE_USERS', value)
        },
        setCurrentUserInfo({ commit }, value) {
            commit('SET_CURRENT_USER_INFO', value);
        },

        newTasks({ commit }, value) {
            commit('NEW_TASKS', value);
        },
        removeTasks({ commit }, value) {
            commit('REMOVE_TASKS', value);
        },
        changeTaskStatus({ commit }, value) {
            commit('CHANGE_TASK_STATUS', value)
        },
        changeUploadSpeed({ commit }, value) {
            commit('CHANGE_UPLOAD_SPEED', value)
        },
        changeUploadProgress({ commit }, value) {
            commit('CHANGE_UPLOAD_PROGRESS', value)
        },
        setCurSelectRecentType({ commit }, value) {
            commit('SET_CUR_SELECT_RECENT_TYPE', value)
        },
        setCurrentFilePage({ commit }, value) {
            commit('SET_CURRENT_FILE_PAGE', value)
        },
        setCurrentMinePage({ commit }, value) {
            commit('SET_CURRENT_MINE_PAGE', value)
        },
        setCurrentStarPage({ commit }, value) {
            commit('SET_CURRENT_STAR_PAGE', value)
        },
        setCurrentKBPage({ commit }, value) {
            commit('SET_CURRENT_KB_PAGE', value)
        },
        setCurrentFileId({ commit }, value) {
            commit('SET_CURRENT_FILE_ID', value)
        },
        setRecentViewShow({ commit }, value) {
            commit('SET_RECENT_VIEW_SHOW', value)
        },
        setCloudI18n({ commit }, value) {
            commit('SET_CLOUD_I18N', value)
        },
        setIsMettingDoc({ commit }, value) {
            commit('SET_IS_METTING_DOC', value)
        },
        setShowType({ commit }, value) {
            commit('SET_SHOW_TYPE', value)
        },
        setUserInfo({ commit }, value) {
            commit('SET_USER_INFO', value)
        },
        setTocaEditor({ commit }, value) {
            commit('SET_TOCA_EDITOR', value);
        },
        setShareAuthTip({ commit }, value) {
            commit('SET_SHARE_AUTH_TIP', value);
        },
        setOfficePreviewModeInfo({ commit }, value) {
            commit('SET_OFFICE_PREVIEW_MODE_INFO', value);
        },
        setWikiSpaceInfo(context, val) {
            context.commit('SET_WIKI_SPACE_INFO', val);
        },
        setCopyPermission(context, val) {
            context.commit('SET_COPY_PERMISSION', val);
        },
        setIsCanCopy(context, val) {
            context.commit('SET_IS_CAN_COPY', val);
        }
    }
})
